import { createFileRoute } from "@tanstack/react-router";
import {
  ArrivingFailed,
  ArrivingLayout,
  ArrivingPending,
} from "@/client/components/arriving-layout";
import { pageTitle } from "@/client/lib/page-title";
import { PENDING_MS } from "@/client/lib/pending";
import { ResetPassword } from "@/features/identity/components/reset-password";
import { resetSearch } from "@/features/identity/search";

export const Route = createFileRoute("/reset-password")({
  pendingMs: PENDING_MS,
  pendingComponent: ArrivingPending,
  errorComponent: ArrivingFailed,
  validateSearch: resetSearch,
  head: async () => {
    const { identityCopy } = await import("@/features/identity/copy");
    return { meta: [{ title: pageTitle(identityCopy.reset.title) }] };
  },
  component: Reset,
});

function Reset() {
  const { token, error } = Route.useSearch();

  return (
    <ArrivingLayout>
      <ResetPassword token={token} expired={error !== undefined} />
    </ArrivingLayout>
  );
}
